import { createReducer, on } from "@ngrx/store";
import { IFormaEnvio, initDespachos } from "../../interfaces/despacho";
import {
  consultarDespachosSuccess,
  esNuevoDespacho,
  expandedTipoDespacho,
  getEntradasByIdEmpresaSuccess,
  guardarFormulariosInfoVobo,
  resetDespacho,
  resetEntradasMoverMrb,
  saveTemasDespacho,
  saveTemasDespachoFailure,
  seleccionarTipoDespacho,
  setContadorSuccess,
  setEntradasByEmpresa,
  setEntradasByEmpresaSuccess,
  setEntradasEmpresaAndDespacho,
  updateCurrentDespacho,
  updateDespacho,
  updateStatusDespacho,
  updateTemaDespacho,
  validarTemasDespacho,
} from "./actions";

export const initialState: IFormaEnvio = initDespachos;

export const despachosReducer = createReducer(
  initialState,
  on(consultarDespachosSuccess, (state, { despachos }) => {
    return { ...state, despachos };
  }),

  on(setEntradasEmpresaAndDespacho, (state, { despacho, entradas }) => {
    return {
      ...state,
      despacho,
      despachos: state.despachos.map((des) => {
        if (des.id_empresa === despacho.id_empresa) {
          return { ...despacho };
        } else {
          return { ...des, expanded: false };
        }
      }),
      entradas: entradas ? entradas : [],
    };
  }),
  on(validarTemasDespacho, (state) => {
    return {
      ...state,
      form: { ...state.form, validar: true, guardando: false },
    };
  }),
  on(saveTemasDespacho, (state) => {
    return {
      ...state,
      form: { ...state.form, validar: false, guardando: true },
    };
  }),
  on(saveTemasDespachoFailure, (state) => {
    return {
      ...state,
      form: { ...state.form, validar: false, guardando: false, error: true },
    };
  }),
  on(updateTemaDespacho, (state, { tipoTema, temas }) => {
    return {
      ...state,
      despachos: state.despachos.map((despacho) => {
        if (
          temas &&
          temas[0] &&
          temas[0].id_empresa &&
          despacho.id_empresa === temas[0].id_empresa
        ) {
          return {
            ...despacho,
            [tipoTema]: temas,
          };
        } else {
          return despacho;
        }
      }),
      despacho: {
        ...state.despacho,
        [tipoTema]: temas,
      },
    };
  }),
  on(
    getEntradasByIdEmpresaSuccess,
    setEntradasByEmpresaSuccess,
    (state, { entradas }) => {
      return {
        ...state,
        entradas,
      };
    }
  ),
  on(esNuevoDespacho, (state) => {
    return {
      ...state,
      nuevoDespacho: !state.nuevoDespacho,
    };
  }),
  on(setContadorSuccess, (state, { contador }) => {
    return {
      ...state,
      contador,
    };
  }),

  on(resetEntradasMoverMrb, (state) => {
    return {
      ...state,
      entradas: [],
    };
  }),

  on(seleccionarTipoDespacho, (state) => {
    return {
      ...state,
      despachos: state.despachos.map((des) => {
        return { ...des, expanded: false };
      }),
      despacho: {
        ...state.despacho,
        expanded: false,
      },
    };
  }),
  on(updateDespacho, (state, { vobo, informativo, id_empresa }) => {
    const updatedInformativo = updateArray(
      state.despacho.Informativo,
      informativo,
      id_empresa
    );
    const updatedVoBo = updateArray(state.despacho.VoBo, vobo, id_empresa);

    console.log("updatedInformativo", updatedInformativo);
    console.log("updatedVoBo", updatedVoBo);

    return {
      ...state,
      despachos: state.despachos.map((des) => {
        if (des.id_empresa === id_empresa) {
          return {
            ...des,
            VoBo: vobo ?? [],
            Informativo: informativo ?? [],
          };
        }
        return des;
      }),
      despacho: {
        ...state.despacho,
        expanded: true,
        Informativo: informativo ?? [],
        VoBo: vobo ?? [],
      },
    };
  }),
  on(expandedTipoDespacho, (state, { currentExpanded }) => {
    return {
      ...state,
      currentExpanded,
    };
  }),
  on(updateCurrentDespacho, (state, { despacho }) => {
    return {
      ...state,
      despacho,
    };
  }),

  on(updateStatusDespacho, (state, { status }) => {
    return {
      ...state,
      status,
    };
  }),

  on(resetDespacho, (state) => {
    return { ...initialState, contador: state.contador };
  })
);
const updateArray = (
  originalArray: any[],
  newArray: any[],
  id_empresa: string
): any[] => {
  if (Array.isArray(originalArray) && originalArray.length > 0) {
    return originalArray.map((item) => {
      const updatedItem = newArray.find(
        (newItem: any) => newItem.id_empresa === item.id_empresa
      );
      if (item.id_empresa === id_empresa) {
        return {
          ...item,
          banEsImpreso: updatedItem
            ? updatedItem.banEsImpreso
            : item.banEsImpreso,
          nombreTema: updatedItem ? updatedItem.nombreTema : item.nombreTema,
          entradas: updatedItem ? updatedItem.entradas : item.entradas,
        };
      } else {
        return item;
      }
    });
  }

  return originalArray;
};
